module.exports = __webpack_public_path__ + "static/pic04-e87d2a72c6bdfbdd2a1926dca5ac24ec.jpeg";